import {FadeInView} from '@/components/basic/animations';
import React, {useState} from 'react';
import HomeLotteryHot from './lottery-hot';
import HomeOtherGames from './other-games';
import HomeLotteryDigit from './lottery-digit';
import HomeLotteryKerala from './lottery-kerala';
import HomeLotteryMix from './lottery-mix';
import HomeLotterySatta from './lottery-satta';
import HomePick11 from './pick11';
import homeStore from '../../home.refresh.service';
import {
  LotteryData,
  getHomeGameList,
  HomeGameFloorItem,
  getHomeHotGames,
  getP11MatchList,
  P11CompetitionItem,
  P11MatchItem,
} from '../../home.service';
import {HomeGameCardItem, IHomeSportsCardItem} from '../../home.type';
import {sportsIconMap, toSportItem} from '@/pages/gr8-sports/converts';
import SportFloor from '@/pages/gr8-sports/components/sport-floor';
import {goTo} from '@/utils';

/** pick11 楼层的数据来源是 api/front/p11/match/list，不依赖 gamesList */
function hasP11Content(list: P11CompetitionItem[] | null): boolean {
  return (list?.some(c => c.matches && c.matches.length > 0) ??
    false) as boolean;
}

const HomeHot = () => {
  const [floors, setFloors] = useState<HomeGameFloorItem[]>([]);
  const [games, setGames] = useState<LotteryData>();
  const [p11Data, setP11Data] = useState<P11CompetitionItem[] | null>(null);
  const [p11AllLen, setP11AllLen] = useState<number>(0);
  // "indianLottery"
  console.log(floors, 'floors');
  const getGameList = async () => {
    try {
      const r = await getHomeHotGames();
      setFloors(r);
      getHomeGameList().then(res => {
        if (res) {
          setGames(res);
        }
      });
    } catch (e) {
      console.log('home hot error: ', e);
    } finally {
      homeStore.refreshEnd.next();
    }
  };

  React.useEffect(() => {
    const hasPick11Floor = floors.some(f => f.uniqueKey === 'pick11');
    if (!hasPick11Floor) {
      setP11Data(null);
      return;
    }
    let cancelled = false;
    getP11MatchList()
      .then(res => {
        if (cancelled) {
          return;
        }
        const raw = (res as any)?.matches ?? [];
        setP11AllLen(res?.upcomingTotal ?? 0);
        const list = Array.isArray(raw) ? raw : [];
        if (list.length > 0 && (list[0] as P11MatchItem).dateStart != null) {
          const pick11Floor = floors.find(f => f.uniqueKey === 'pick11');
          setP11Data([
            {
              fantasyCompetitionTitle: pick11Floor?.name,
              matches: list as P11MatchItem[],
            },
          ]);
        } else {
          setP11Data(list as P11CompetitionItem[]);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setP11Data([]);
        }
      });
    return () => {
      cancelled = true;
    };
  }, [floors]);

  React.useEffect(() => {
    getGameList();
    const sub = homeStore.refresh.subscribe(() => {
      getGameList();
    });
    return () => {
      sub.unsubscribe();
    };
  }, []);

  const handleLink = (floor: HomeGameFloorItem) => {
    if (floor.uniqueKey === 'HotMatches') {
      return goTo('Sports', {
        path: '/cricket',
      });
    }
    if (floor.uniqueKey === 'TableTennis') {
      return goTo('Sports', {
        path: '/table-tennis/live',
      });
    }
    if (floor.uniqueKey === 'CyberSport') {
      return goTo('Sports', {
        path: '/e-sports/live',
      });
    }
    return goTo('Sports', {
      path: `/${floor.uniqueKey.toLowerCase()}/live`,
    });
  };

  const renderSportFloor = (floor: HomeGameFloorItem) => {
    if (floor.tagName?.endsWith('_sport')) {
      // 确定是体育内容，判断gamesList存在的情况
      if (!floor.gamesList?.length) {
        return null;
      }
      try {
        const gamesList = floor.gamesList as IHomeSportsCardItem[];
        const sport = floor.tagName?.split('_')[0];
        const isSport =
          gamesList[0].grSportName.toLowerCase() === sport.toLowerCase();
        const isHotOrPremierLeague =
          floor.uniqueKey === 'HotMatches' ||
          floor.uniqueKey === 'PremierLeague' ||
          floor.uniqueKey === 'Premier League';
        return (
          <SportFloor
            title={floor.name}
            icon={floor.categoryPic}
            sportsList={gamesList.map(game => toSportItem(game))}
            hasLink={isSport || isHotOrPremierLeague}
            hasLiveIcon={isSport}
            onLinkClick={() => handleLink(floor)}
            isSport={isSport}
            defaultSportIcon={
              floor.categoryPic ||
              sportsIconMap[sport as keyof typeof sportsIconMap] ||
              undefined
            }
          />
        );
      } catch (e) {
        // 体育接口数据格式错误，不解析
        console.log('home hot error: ', e);
        return null;
      }
    }
    return null;
  };
  return (
    <FadeInView
      style={[
        // eslint-disable-next-line react-native/no-inline-styles
        {
          height: 'auto',
        },
      ]}>
      {games ? (
        !!floors.length &&
        floors.map((item, index) => (
          <div key={index}>
            {item.uniqueKey === 'HotGmae' && (
              <HomeLotteryHot data={item.gamesList as HomeGameCardItem[]} />
            )}
            {item.gamesList &&
              item.gamesList.length &&
              item.uniqueKey === '3DigitGame' && (
                <HomeLotteryDigit
                  serverTime={item.currentTimestamp || games.currentTimestamp}
                  // @ts-ignore
                  list={item.gamesList as HomeGameCardItem[]}
                  batchList={games.pickResList}
                />
              )}
            {item.gamesList &&
              item.gamesList.length &&
              ['indianLottery', 'StateLottery'].includes(item.uniqueKey) && (
                <HomeLotteryMix
                  serverTime={item.currentTimestamp || games.currentTimestamp}
                  // @ts-ignore
                  list={item.gamesList as HomeGameCardItem[]}
                  batchList={games.stateLotteryList}
                />
              )}
            {item.gamesList &&
              item.gamesList.length &&
              item.uniqueKey === 'KeralaLottery' && (
                <HomeLotteryKerala
                  serverTime={item.currentTimestamp || games.currentTimestamp}
                  // @ts-ignore
                  list={(item.gamesList as HomeGameCardItem[]) || []}
                  batchList={games.keralaResList}
                />
              )}
            {item.gamesList &&
              item.gamesList.length &&
              item.uniqueKey === 'SattaMatka' && (
                <HomeLotterySatta
                  serverTime={item.currentTimestamp || games.currentTimestamp}
                  // @ts-ignore
                  list={item.gamesList}
                  batchList={games.matkaResList}
                />
              )}
            {item.uniqueKey === 'pick11' && hasP11Content(p11Data) && (
              <HomePick11 data={item} p11Data={p11Data!} allLen={p11AllLen} />
            )}
            {renderSportFloor(item)}
            {item.gamesList &&
              item.gamesList.length &&
              ![
                'HotGmae',
                '3DigitGame',
                'StateLottery',
                'KeralaLottery',
                'SattaMatka',
                'indianLottery',
              ].includes(item.uniqueKey) &&
              !item.tagName?.endsWith('_sport') &&
              item.uniqueKey !== 'pick11' && <HomeOtherGames data={item} />}
          </div>
        ))
      ) : (
        <></>
      )}
      {/* {games ? (
        <>
          <HomeLotteryHot />
          <HomeLotteryDigit
            serverTime={games.currentTimestamp}
            list={games.pickResList}
          />
          <HomeLotteryMix
            serverTime={games.currentTimestamp}
            list={games.stateLotteryList}
          />
          <HomeLotteryKerala
            serverTime={games.currentTimestamp}
            list={games.keralaResList}
          />
          <HomeLotterySatta
            serverTime={games.currentTimestamp}
            list={games.matkaResList}
          />
        </>
      ) : (
        <></>
      )} */}
    </FadeInView>
  );
};

export default HomeHot;
